<div class="orderline-panel">
  <div class="orderline-header">
    <h2>{{title}}</h2>
    <div>
      <label>Admin:</label>
      <select [ngModel]="selectedAdmin" (ngModelChange)="onSelectedAdminChanged($event)">
        <option [ngValue]="null">[Select an Admin]</option>
        <option [ngValue]="0">All Admins</option>
        <option *ngFor="let a of admins$ | async" [ngValue]="a.AdminID">{{a.AdminName}}</option>
      </select>
    </div>
  </div>

  <div class="orderline-body">
    <ng-container *ngIf="datasource !== null">
      <div class="left">
        <app-orderline-tree [datasource]="datasource" [nodes]="nodes" [selectionChanged]="selectionChanged" (selectedNodeChange)="onSelectedNodeChanged($event)"></app-orderline-tree>
      </div>
      <div class="right">
        <app-orderline-grid [datasource]="datasource" [selectedNode]="selectedNode" (selectionChanged)="onSelectionChanged()"></app-orderline-grid>
      </div>
    </ng-container>
  </div>

  <div class="orderline-footer">
    <button (click)="onEditOrders()">Edit Orders</button>
  </div>
</div>
